import { CashScreen, type CashSection, cashLinkOf } from '@felix/ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { officeCashSource } from '../cash-source.js';
import { Shell } from '../components/Shell.js';

/**
 * Finance ▸ Cash to Master ve Cash Account (ADR 0093): kasa gemiden gelir, ofiste salt okunur;
 * CTM kararı, ödeme düzenlemesi ve sayım incelemesi ofiste. Bölüm menü yaprağından.
 */
export function CashPage({ section }: { section: CashSection }) {
  const { t } = useTranslation();
  const source = useMemo(() => officeCashSource(), []);
  // Panodaki iş satırı `?vessel=&id=` (ADR 0156): CTM seçilir, sayım satırı işaretlenir
  const { search } = useLocation();
  const initial = useMemo(() => cashLinkOf(search), [search]);
  return (
    <Shell title={t(`cash.sections.${section}.title`)}>
      <CashScreen
        // Zilden başka bir kayda gidilince ekran yeniden kurulur
        key={`${section}${search}`}
        source={source}
        section={section}
        initial={initial}
        today={new Date().toISOString().slice(0, 10)}
      />
    </Shell>
  );
}
